import { Button } from '@99designs/common/components/Button';
import { Icon } from '@99designs/common/components/Icon';
import { Element, Footer as FooterBar } from 'common/components/FooterBar';
import Responsive from 'common/components/Responsive';
import ActionStatus from 'projects/components/ActionStatus';
import Portal from 'projects/components/Portal';
import { Color } from 'projects/consts';
import React from 'react';
import ColorComponent from './Color';

export interface Props {
    nextAction: () => void;
    nextActionLabel: string;
    disabled?: boolean;
}

export const SquarespaceFooterButton: React.SFC<{
    icon: React.ReactNode;
    variations: string[];
    onClick: () => void;
    disabled?: boolean;
}> = props => (
    <Button
        variations={props.variations}
        icon={props.icon}
        iconAlignment="right"
        isDisabled={props.disabled}
        onClick={props.onClick}
    >
        {props.children}
    </Button>
);

const SquarespaceFooterAction = ({ nextAction, nextActionLabel, disabled = false }: Props) => (
    <SquarespaceFooterButton
        disabled={disabled}
        variations={['primary', 'nowrap', 'responsive', 'chameleon', 'jumbo']}
        onClick={nextAction}
        icon={<Icon type={'right-4'} />}
    >
        {nextActionLabel}
    </SquarespaceFooterButton>
);

const SquarespaceFooter: React.SFC<Props> = props => {
    const { children } = props;
    return (
        <Portal>
            <ColorComponent color={Color.squarespaceBlack}>
                <Responsive min="normal">
                    <FooterBar>
                        <Element align="left" cols={6}>
                            {children ? children : <ActionStatus active={false} />}
                        </Element>
                        <Element align="right" cols={6}>
                            <SquarespaceFooterAction {...props} />
                        </Element>
                    </FooterBar>
                </Responsive>
                <Responsive max="medium">
                    <FooterBar position={'sticky'}>
                        <Element align="right">
                            <SquarespaceFooterAction {...props} />
                        </Element>
                    </FooterBar>
                </Responsive>
            </ColorComponent>
        </Portal>
    );
};

export default SquarespaceFooter;
